import { AppDrawerForm } from "./AppDrawerForm";
import { AppModalForm } from "./AppModalForm";
import { FormContainerStateReturnType } from "../../hooks";

export type AppFormContainerProps = {
    title: string;
    state: FormContainerStateReturnType;
    children: JSX.Element;
    type?: "drawer" | "modal";
    size?: string;
    isFooter?: boolean;
    submitLabel?: string;
};

export const AppFormContainer = ({
    title,
    state,
    children,
    type = "drawer",
    size = "md",
    isFooter = true,
    submitLabel = "",
}: AppFormContainerProps) => {
    if (type === "modal") {
        return (
            <AppModalForm
                title={title}
                state={state}
                size={size}
                isFooter={isFooter}
                submitLabel={submitLabel}
            >
                {children}
            </AppModalForm>
        );
    }

    return (
        <AppDrawerForm
            title={title}
            state={state}
            size={size}
            isFooter={isFooter}
        >
            {children}
        </AppDrawerForm>
    );
};
